<template lang='pug'>
  div
    el-upload(action='', :auto-upload='true', :file-list="fileList",
      :http-request="customRequest", ref="upload", :multiple="true")
      el-button(size="small", type="primary") 点击选取附件进行上传
    //el-button(@click="debug")
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  props: {
    opts: Object
  },
  data: function() {
    return {
      fileList: [],
      uploaded: []
    };
  },
  methods: {
    submit: function() {
      return this.$refs['upload'].submit();
    },
    clear: function() {
      return this.uploaded = [];
    },
    customRequest: function(header) {
      var file, reader;
      file = header['file'];
      reader = new FileReader();
      reader.onload = (e) => {
        var content, fname;
        fname = file.name;
        content = e.target.result.replace(/^.*?,/, '');
        return app.api.upload({
          fname: fname,
          content: content
        }).then((res) => {
          this.uploaded.push(fname);
          this.$emit('success', fname);
          return this.$message(`${file.name}上传成功!`);
        }).catch((e) => {
          return this.$message(`${file.name}上传失败`);
        });
      };
      return reader.readAsDataURL(file);
    }
  }
};
</script>

